import request, { _POST } from "@/services/request";

export type ExternalMaterialPlatform = "EXTERNAL_MATERIAL_PLATFORM_INVALID" | "EXTERNAL_MATERIAL_PLATFORM_QUNJIELONG";

export type SaveExternalMaterialReq = {
  headSupplierItemLink?: string;
  platform?: ExternalMaterialPlatform;
  externalId?: string;
  item?: unknown;
};

export type SaveExternalMaterialRsp = {
  id?: string;
};

export type DeleteExternalMaterialReq = {
  /** 本地素材 ID 列表，优先使用 */
  ids?: string[];
  platform?: ExternalMaterialPlatform;
  /** 外部平台素材 ID 列表 */
  externalIds?: string[];
};

export type ListExternalMaterialReq = {
  headSupplierItemLink?: string;
  page?: number;
  size?: number;
  platform?: ExternalMaterialPlatform;
};

export type ExternalMaterialItem = {
  id?: string;
  platform?: ExternalMaterialPlatform;
  externalId?: string;
  item?: unknown;
  createdAt?: string;
  updatedAt?: string;
};

export type ListExternalMaterialRsp = {
  list?: ExternalMaterialItem[];
  total?: number | string;
};

const saveExternalMaterial = (params: SaveExternalMaterialReq) =>
  request<SaveExternalMaterialRsp, SaveExternalMaterialReq>(_POST, "/admin/externalMaterial/save")(params);

const deleteExternalMaterial = (params: DeleteExternalMaterialReq) =>
  request<null, DeleteExternalMaterialReq>(_POST, "/admin/externalMaterial/delete")(params);

const listExternalMaterial = (params?: ListExternalMaterialReq) =>
  request<ListExternalMaterialRsp, ListExternalMaterialReq>(_POST, "/admin/externalMaterial/list")(params ?? {});

const externalMaterialApis = {
  saveExternalMaterial,
  deleteExternalMaterial,
  listExternalMaterial,
};

export default externalMaterialApis;
